import { render, staticRenderFns } from "./OriginDescription.vue?vue&type=template&id=846e5380&scoped=true"
import script from "./OriginDescription.vue?vue&type=script&lang=js"
export * from "./OriginDescription.vue?vue&type=script&lang=js"
import style0 from "./OriginDescription.vue?vue&type=style&index=0&id=846e5380&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846e5380",
  null
  
)

export default component.exports